import type { ClassValue } from 'clsx';
import classNames from 'clsx';
import React from 'react';

import { Icon } from '@swf/sports/components';
import type { IconName } from '@swf/sports/types/icon';

import styles from './Badges.scss';

interface BadgesProps {
  count?: number;
  className?: ClassValue;
  iconName: IconName;
  iconLabel: string;
  text?: string;
}

const Badges: React.FC<BadgesProps> = ({ count, className, iconName, iconLabel, text }) => (
  <div className={classNames(styles.container, className)}>
    {count ? (
      <span data-testid="badges-count" className={styles.count}>
        {count}
      </span>
    ) : null}

    {text ? (
      <span className={styles.iconText}>
        <Icon label={iconLabel} name={iconName} size="lg" />
        {text}
      </span>
    ) : (
      <Icon label={iconLabel} name={iconName} size="lg" />
    )}
  </div>
);

export type { BadgesProps };
export default Badges;
